var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from "react";
var waitForEmbeddedService = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var interval = setInterval(function () {
                    if (window.embedded_svc && window.embedded_svc.liveAgentAPI) {
                        clearInterval(interval);
                        resolve(window.embedded_svc);
                    }
                }, 100);
            })];
    });
}); };
function usePrevious(value) {
    var _a;
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return (_a = ref.current) !== null && _a !== void 0 ? _a : value;
}
function useLiveAgentAPI(props) {
    var _this = this;
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var es;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, waitForEmbeddedService()];
                    case 1:
                        es = _b.sent();
                        es.settings.extraPrechatFormDetails = [
                            {
                                label: "Reason for Chatting",
                                transcriptFields: ["Reason_for_Chatting__c"],
                                displayToAgent: true,
                            },
                            {
                                label: "First Name",
                                transcriptFields: ["Enquirer_First_Name__c"],
                                displayToAgent: true,
                            },
                            {
                                label: "Last Name",
                                transcriptFields: ["Enquirer_Last_Name__c"],
                                displayToAgent: true,
                            },
                            {
                                label: "CaseRecordId",
                                fieldName: "Id",
                                value: props.caseId,
                                displayToAgent: true,
                            },
                            {
                                label: "TranscriptRecordId",
                                fieldName: "TranscriptId",
                                value: props.transcriptId,
                                displayToAgent: true,
                            },
                            {
                                label: "AccountId",
                                fieldName: "AccountId",
                                value: props.accountId,
                                displayToAgent: true,
                            },
                        ];
                        es.settings.extraPrechatInfo = [
                            {
                                entityName: "Case",
                                showOnCreate: true,
                                saveToTranscript: "Case",
                                entityFieldMaps: [
                                    {
                                        isExactMatch: true,
                                        fieldName: "Id",
                                        doCreate: false,
                                        doFind: true,
                                        label: "CaseRecordId",
                                    },
                                ],
                            },
                            {
                                entityName: "LiveChatTranscript",
                                showOnCreate: true,
                                saveToTranscript: "Transcript",
                                entityFieldMaps: [
                                    {
                                        isExactMatch: true,
                                        fieldName: "TranscriptId",
                                        doCreate: false,
                                        doFind: true,
                                        label: "TranscriptRecordId",
                                    },
                                ],
                            },
                            {
                                entityName: "Contact",
                                saveToTranscript: "Contact",
                                showOnCreate: true,
                                entityFieldMaps: [
                                    {
                                        doCreate: false,
                                        doFind: true,
                                        fieldName: "LastName",
                                        isExactMatch: true,
                                        label: "Last Name",
                                    },
                                    {
                                        doCreate: false,
                                        doFind: true,
                                        fieldName: "FirstName",
                                        isExactMatch: true,
                                        label: "First Name",
                                    },
                                    {
                                        doCreate: false,
                                        doFind: true,
                                        fieldName: "Email",
                                        isExactMatch: true,
                                        label: "Email",
                                    },
                                ],
                            },
                        ];
                        es.settings.prepopulatedPrechatFields = {
                            FirstName: props.firstName,
                            LastName: props.lastName,
                            Email: props.email,
                            Reason_for_Chatting__c: (_a = props.department) === null || _a === void 0 ? void 0 : _a.transcriptReason,
                            CaseRecordId: props.caseId,
                            TranscriptRecordId: props.transcriptId,
                        };
                        es.liveAgentAPI.startChat();
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
}
function useLiveAgentChatState() {
    var _a = useState(false), isLiveagentChatOpen = _a[0], setIsLiveagentChatOpen = _a[1];
    useEffect(function () {
        var interval = setInterval(function () {
            var element = document.querySelector(".embeddedServiceSidebar");
            setIsLiveagentChatOpen(!!element);
        }, 100);
        return function () {
            clearInterval(interval);
        };
    }, []);
    return isLiveagentChatOpen;
}
function useLiveAgentChatCallbacks(isLiveagentChatOpen, onOpen, onClose) {
    var wasLiveagentChatOpen = usePrevious(isLiveagentChatOpen);
    useEffect(function () {
        if (wasLiveagentChatOpen && !isLiveagentChatOpen) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        if (!wasLiveagentChatOpen && isLiveagentChatOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    }, [isLiveagentChatOpen, wasLiveagentChatOpen, onOpen, onClose]);
}
var LiveagentChat = function (props) {
    useLiveAgentAPI(props);
    var isLiveagentChatOpen = useLiveAgentChatState();
    useLiveAgentChatCallbacks(isLiveagentChatOpen, props.onOpen, props.onClose);
    return null;
};
export default LiveagentChat;
